import React from 'react';
import './OurWork.css';
import WorksData from '../../assest/data/WorksData';
import { useTranslation } from 'react-i18next';


function OurWork() {
    const { t, i18n } = useTranslation();
  return (
    <>
    <div className='our-works' data-aos='fade-up'>
        <div className='ourWorkHolder'>
      <div className='OurWorkCard'>
        <WorksData/>
      </div>
      </div>
    </div>
    </>
  )
}

export default OurWork